<template>
  <div>
    <div v-show="isVisible" class="overlay" @click.stop></div>
    <v-card v-show="isVisible" class="payment-modal" @click.stop>
      <div class="modal-header">
        <!--<h4 class="modal-title">Completa la información</h4>-->
        <button
          class="close-btn"
          @click="handleClose"
          style="
            position: absolute;
            top: 8px;
            right: 8px;
            background: transparent;
            border: none;
            font-size: 1.2rem;
            cursor: pointer;
          "
        >
          &times;
        </button>
      </div>

      <div class="modal-content">
        <!-- 1) Spinner mientras llega la respuesta -->
        <Loading v-if="isLoading" />

        <!-- 2) Contenedor vacío: el SDK de Toku inyectará aquí el iframe -->
        <div v-else id="toku-container" class="toku-container-wrapper"></div>
      </div>
      <div
        class="modal-footer"
        style="padding: 16px; border-top: 1px solid #eee; text-align: right"
      >
        <button type="button" class="btn btn-secondary" @click="handleClose">
          Volver
        </button>
      </div>
    </v-card>
    <ModalEstadoTransaccion ref="transactionModal" />
  </div>
</template>

<script>
import Loading from "../isep/Tools/loading.vue";
import ModalEstadoTransaccion from "./ModalEstadoTransaccion.vue";
import { mapGetters } from "vuex";

export default {
  name: "ModalFormaDePago",
  components: { Loading, ModalEstadoTransaccion },

  data() {
    return {
      isVisible: false,
      isLoading: false,
      importePagar: 0,
      idBanco: 0,
      checkoutSessionId: "",
      urlToku: "",
      referenciaPago: ""
    };
  },
  computed: {
    ...mapGetters(["getPolizaData"]),
    ...mapGetters(["getSelectedEndosos"]),
    currentFormattedDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
  },

  methods: {
    // Este método es invocado desde tu componente padre:
    // this.$refs.paymentModal.setBancoData({ importePagar, idBanco })
    async setBancoData({ importePagar, idBanco = 0, referenciaPago }) {
      this.importePagar = Number(importePagar) || 0;
      this.idBanco = idBanco;
      this.referenciaPago = referenciaPago
      this.openModal();
      await this.consultaFormaPago();
    },
    handleClose() {
      this.closeModal();
      // Navegar a la ruta /pago-en-linea/paso-1
      this.$router.push("/pago-en-linea/paso-1");
    },
    openModal() {
      this.isVisible = true;
      document.body.style.overflow = "hidden";
    },
    closeModal() {
      this.isVisible = false;
      document.body.style.overflow = "";
    },

    // Paso 1: Llamas al endpoint que ya te regresa { id, url }
    async consultaFormaPago() {
      // Verificar si hay datos en la store
      if (this.$store.state.datosPolizaProvenientesUrl) {
        const datosPoliza = this.$store.state.datosPolizaProvenientesUrl;

        this.datosGenerales = datosPoliza.pDatosGenerales;
        this.datosRecibo = datosPoliza.pDatosRecibo;
        this.datosEndosos = datosPoliza.pEndosos;
      }

      if (this.getPolizaData) {
        this.datosGenerales = this.getPolizaData.pDatosGenerales;
        this.datosRecibo = this.getPolizaData.pDatosRecibo;
        this.datosEndosos = this.getPolizaData.pEndosos;
      }

      const referenciaElegida =
        this.datosRecibo && this.datosRecibo.pReferencia
          ? this.datosRecibo.pReferencia
          : Array.isArray(this.datosEndosos) && this.datosEndosos.length
          ? this.datosEndosos[0].pReferencia
          : "";

          console.log("Referencia para envio de pago");
          console.log(this.referenciaPago);

      // Construcción del payload
      const payload = {
        metodo: "CONSULTARFORMAPAGO",
        data: {
          montoTotal: this.importePagar,
          idAplicacon: localStorage.getItem("applicationNumber"),
          //idBanco: this.idBanco,
          idBanco: 4,
          referencia: this.referenciaPago,
          usuario: localStorage.getItem("profileId"),
          pDatosGenerales: {
            pRamoLetra: this.datosGenerales?.pRamoLetra || "",
            pRamo: this.datosGenerales?.pRamo || "",
            pPoliza: this.datosGenerales?.pPoliza || "",
            pProducto: this.datosGenerales?.pProducto || "",
            pAgente: this.datosGenerales?.pAgente || "",
            pSistema: this.datosGenerales?.pSistema || "",
            pTipoPoliza: this.datosGenerales?.pTipoPoliza || "",
            pFormaPago: this.datosGenerales?.pFormaPago || "",
          },
          pDatosRecibo: {
            pContratante: this.datosRecibo?.pContratante || "",
            pNumFilial: this.datosRecibo?.pNumFilial || "",
            pEndoso: this.datosRecibo?.pEndoso || "",
            pNumInciso: this.datosRecibo?.pNumInciso || "",
            pRecibo: this.datosRecibo?.pRecibo || "",
            pEstatus: this.datosRecibo?.pEstatus || "",
            pImporteRecibo: this.datosRecibo?.pImporteRecibo || 0,
            pMoneda: this.datosRecibo?.pMoneda || "",
            pFechaVencimiento: this.datosRecibo?.pFechaVencimiento || "",
            pReferencia: this.datosRecibo?.pReferencia || "",
            pIdClienteCU: this.datosRecibo?.pIdClienteCU || "",
            pRamoDescripcion: this.datosRecibo?.pRamoDescripcion || "",
          },
          pEndosos: this.datosEndosos || [],
        },
      };

      try {
        const { data } = await this.$store.dispatch("metodoPost", payload);
        if (data.id && data.url) {
          // Guardas la sesión
          this.checkoutSessionId = data.id;
          this.urlToku = data.url;
          // Paso 2: Inyectas el portal con el SDK
          this.initToku(this.checkoutSessionId, this.urlToku);
        } else {
          throw new Error("No se obtuvo id/url de Toku");
        }
      } catch (err) {
        this.$swal(
          "Error",
          err.message || "Falló la consulta de pago",
          "error"
        );
        this.closeModal();
      } finally {
        this.isLoading = false;
      }
    },

    // Paso 3: Usas el SDK con el checkoutSessionId
    initToku(sessionId) {
      // window.Toku viene de tu <script> en index.html
      const toku = new window.Toku(
        "rhwQtN_QGr6s4d7i9XySCKLgvkN7yZcpM5AXLaI7g0A",
        {
          containerId: "toku-container",
          iframeId: "toku-frame",
          onSuccess: (payload) => this.onTokuSuccess(payload),
          onError: (err) => this.onTokuError(err),
        }
      );
      toku.init("onDemandRecurringCheckout", {
        checkoutSessionId: sessionId,
      });
    },

    onTokuSuccess(payload) {
      //this.closeModal();
      /*this.$refs.transactionModal.openModal({
        statusIcon:       "success",
        statusMessage:    "Transacción autorizada",
        transactionDetails: payload,
      });*/
    },

    onTokuError(err) {
      this.$swal("Error", "Hubo un problema con el pago.", "error");
      // this.closeModal();
    },
  },
};
</script>


<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
}

.payment-modal {
  /* 1) Convierto la tarjeta en un contenedor flex vertical */
  display: flex;
  flex-direction: column;

  /* el resto de tus reglas */
  width: 90vw;
  max-width: 600px;
  min-width: 300px;

  height: 80vh;
  max-height: 700px;
  min-height: 500px;

  margin: 20px auto;
  padding: 20px;
  border-radius: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: white;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1010;

  /* evito scroll en la tarjeta principal */
  overflow: hidden;
}

.modal-content {
  border: none;
}
.modal-header {
  flex: 0 0 auto;
}
.modal-content {
  flex: 1 1 auto;
  padding: 0;
  display: flex;
  overflow: hidden;
}

/* 4) El wrapper del SDK crece para llenar */
.toku-container-wrapper {
  flex: 1 1 auto;
  /* por si acaso */
  width: 100%;
  height: 100%;
}

::v-deep #toku-frame {
  width: 100% !important;
  height: 100% !important;
  border: none;
  overflow: hidden;
}

.modal-title {
  color: #003366;
  font-size: 18px;
  font-weight: bold;
}

.payment-option {
  background-color: #f0f0f0;
  margin-bottom: 10px;
}

.payment-option:hover {
  background-color: #e0e0e0;
}

.amount-text {
  text-align: center;
  margin-top: 20px;
  font-size: 16px;
  font-weight: bold;
}

.cancel-btn {
  background-color: #03132b !important;
  color: white;
}

.confirm-btn {
  background-color: #28a745 !important;
  color: white;
}
.error-btn {
  background-color: #a72828 !important;
  color: white;
}
</style>